/**
 * App subtype helpers for catalog tools (web vs bot).
 */

export function isBotApp(tool) {
  if (!tool) return false;
  return tool.toolType === 'App' && (tool.appSubtype || 'web') === 'bot';
}

export function getToolTypeBadgeSuffix(tool) {
  if (!tool) return 'APP';
  if (tool.toolType === 'Gem') return 'GEM';
  if (isBotApp(tool)) return 'BOT';
  return 'APP';
}

export function toolHasWebUrl(tool) {
  if (hasDynamicBotLaunch(tool)) {
    return Boolean(tool?.botLaunchOptions?.web);
  }
  return Boolean(tool?.botLaunchOptions?.web || (tool?.url || '').trim());
}

export function toolHasRcAppUrl(tool) {
  if (hasDynamicBotLaunch(tool)) {
    return Boolean(tool?.botLaunchOptions?.rcApp);
  }
  return Boolean(tool?.botLaunchOptions?.rcApp || (tool?.rcAppUrl || '').trim());
}

export function hasDynamicBotLaunch(tool) {
  return Boolean(isBotApp(tool) && tool?.botLaunchOptions?.dynamic);
}

export function getToolCardClickAction(tool, { onOpenTool, handleLaunchTool }) {
  if (isBotApp(tool)) {
    return () => onOpenTool?.(tool.id);
  }
  if (tool?.toolType === 'Gem' || toolHasWebUrl(tool)) {
    return () => handleLaunchTool?.(tool);
  }
  return () => onOpenTool?.(tool.id);
}

export function parseStepsText(text) {
  return (text || '')
    .split('\n')
    .map((line) => line.trim())
    .filter(Boolean);
}

export function formatStepsForForm(steps) {
  if (!Array.isArray(steps) || steps.length === 0) return '';
  return steps.join('\n');
}

export function getStepsPreview(steps, limit = 3) {
  if (!Array.isArray(steps) || steps.length === 0) return [];
  return steps.slice(0, limit);
}

export async function launchToolAtUrl(tool, url, { garageAPI, userEmail, onToolLaunch, target } = {}) {
  const targetUrl = (url || '').trim();
  if (!tool || (!targetUrl && !hasDynamicBotLaunch(tool))) return;

  if (onToolLaunch) {
    return onToolLaunch({ ...tool, url: targetUrl, botLaunchTarget: target });
  }

  try {
    if (garageAPI && userEmail) {
      await garageAPI.logToolUsage(tool.id, userEmail);
    }
  } catch (error) {
    console.error('Failed to log tool usage:', error);
  }

  window.open(targetUrl, '_blank');
}
